import React from 'react'
import { PromotionalBanner } from '../../components/promotionalBanner/promotionalBanner.component'
import { Banner } from '../../components/banner/banner.component'
import { JuryMemberList } from '../juryMemberList/juryMemberList.component'
import { ProfileCard } from '../../components/profileCard/profileCard.component'
import { TrendingCardList } from '../trendingCardList/trendingCardList.component'
import { LatestIdeasList } from '../latestIdeasList/latestIdeasList'
import { IdeasList } from '../ideasList/ideasList.component'
import logo from '../../assets/images/new-logo.png'
export const Feeds = () => {
    return (
        <>
            <div className="app-content content">
                <div className="content-overlay"></div>
                <div className="header-navbar-shadow">
                    <img src={logo} className="d-none d-lg-block" alt="img" />
                </div>
                <div className="content-wrapper">
                    <div className="content-body">
                        <div className="row">
                            <div className="col-12 col-lg-12">
                                <div className="row">
                                    <PromotionalBanner />
                                    <div className="col-12 col-lg-4">
                                        <ProfileCard />
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-12 col-lg-5 order-0 order-lg-0'>
                                        <Banner />

                                    </div>
                                    <div className='col-12 col-lg-3 order-2 order-lg-1'>
                                        <JuryMemberList />

                                    </div>
                                    <div className='col-12 col-lg-4 order-1 order-lg-2'>
                                        <TrendingCardList />
                                    </div>
                                </div>
                                <div className='row overflow-auto'>
                                    <LatestIdeasList />
                                </div>
                                <IdeasList />
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}